<template>
  <div class="d-inline-block">
    <b-icon v-b-modal.modal-assign-trainer icon="gear-fill"></b-icon>
    <b-modal
      id="modal-assign-trainer"
      centered
      title="Выбір тренера"
      @hidden="resetModal"
      :hide-footer="true"
    >
      <p v-if="chosenTrainer" class="fw-bold">
        Обраний тренер : {{ chosenTrainer.name }} {{ chosenTrainer.surname }}
      </p>
      <b-form-input v-model="trainerSearch" placeholder="Пошук від 2-ох літер">
      </b-form-input>
      <div v-if="filteredTrainers.length">
        <b-list-group v-for="trainer in filteredTrainers" :key="trainer.id">
          <b-list-group-item href="#" @click="setTrainer(trainer)">
            <b-avatar :src="trainerPicUrl(trainer.id)"></b-avatar>
            <span>{{ trainer.name }} {{ trainer.surname }}</span>
          </b-list-group-item>
        </b-list-group>
      </div>
      <b-button
        variant="outline-success"
        class="mt-4"
        v-if="chosenTrainer"
        @click="setClientTrainer"
        >Підтвердити</b-button
      >
    </b-modal>
  </div>
</template>

<script>
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
export default {
  name: "AssignTrainer",
  props: {
    client: Object,
  },
  data: function () {
    return {
      trainersList: [],
      trainerSearch: null,
      chosenTrainer: null,
      filteredTrainers: [],
    };
  },
  watch: {
    trainerSearch: function (newVal) {
      if (newVal.length < 2) {
        this.filteredTrainers = [];
        return;
      }
      this.filteredTrainers = this.trainersList.filter((trainer) => {
        return (
          trainer.name.includes(capitalizeFirstLetter(newVal)) ||
          trainer.surname.includes(capitalizeFirstLetter(newVal))
        );
      });
    },
  },
  async mounted() {
    await this.getTrainers();
  },
  methods: {
    resetModal() {
      this.chosenTrainer = null;
    },
    trainerPicUrl(trainer) {
      return process.env.VUE_APP_API + "/trainers/photo/" + trainer;
    },
    async getTrainers() {
      let response = await this.$api.trainers.getTrainersList();
      this.trainersList = response.data;
    },
    setTrainer(trainer) {
      this.chosenTrainer = trainer;
      this.filteredTrainers = [];
    },
    async setClientTrainer() {
      await this.$api.clients.patchClient({
        client_id: this.client.id,
        name: this.client.name,
        surname: this.client.surname,
        cardnumber: this.client.cardnumber,
        phonenum: this.client.phonenum,
        birthday: this.client.birthday,
        gender: this.client.gender,
        trainer: this.chosenTrainer.id,
      });
      this.$emit("refresh");
      this.$nextTick(() => {
        this.$bvModal.hide("modal-assign-trainer");
      });
    },
  },
};
</script>

<style scoped></style>
